// extracted by mini-css-extract-plugin
export var checkbox = "_3q-0";
export var circle = "_3q-3";
export var horizontalContainer = "_3q-7";
export var sm = "_3q-5";
export var switch0 = "_3q-2";
export var switchDisabled = "_3q-8";
export var switchEnabled = "_3q-1";
export var textSwitchContainer = "_3q-9";
export var textSwitchOption = "_3q-a";
export var textSwitchOptionSelected = "_3q-b";
export var verticalContainer = "_3q-6";
export var xs = "_3q-4";